<template>
      <b-nav-item-dropdown right no-caret class="account-dropdown">
        <template slot="button-content">
          <a class="nav-link header-item mr-2">
            {{globals.username}}
            <icon icon="chevron-down"></icon>
          </a>
        </template>
        <b-dropdown-item><a target="_blank" href="/">{{$t('OPENSITEINNEWWINDOW')}}</a></b-dropdown-item>
        <b-dropdown-item v-on:click.prevent="logout"><a href="">{{$t('LOGOUT')}}</a></b-dropdown-item>
      </b-nav-item-dropdown>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default
{
  name: 'header-dropdown-accnt',
  methods:
  {
    ...mapActions([
      'logout'
    ])
  },
  computed:
  {
    ...mapGetters([
      'globals'
    ])
  }
}
</script>
